<template>
  <div v-if="isMaxScreen">
    <Head></Head>
    <div class="pc_success-order">
      <div style="flex: 1; overflow-y: auto; height: 100%">
        <PC-order-step></PC-order-step>
        <PC-bread-nav></PC-bread-nav>
        <div class="success-main">
          <success-main :data="data"></success-main>
        </div>
        <PCButton
          :btnTitle="$t('successOrder.successOrder.647s39cv77s0')"
          :disabled="false"
          @handleSubmit="handleSubmit"
        ></PCButton>
      </div>
    </div>
  </div>
  <div v-else class="success-order">
    <h-head></h-head>
    <div class="h5_success-order">
      <div style="flex: 1; overflow-y: auto; height: 100%">
        <PC-order-step></PC-order-step>
        <div class="success-main">
          <success-main :data="data"></success-main>
          <div class="footer">
            <van-button class="btn-active" @click="handleSubmit">{{
              $t('successOrder.successOrder.647s39cv77s0')
            }}</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import hHead from '@/components/layout/head.vue';
import PCBreadNav from '@/components/PCBreadNav';
import PCButton from '@/components/PCButton';
import PCOrderStep from '@/components/PCOrderStep';
import { getChannelId } from '@/utils/channel';

import Head from '../../components/head';
import successMain from './components/successMain.vue';

export default {
  name: 'SuccessOrder',
  components: {
    Head,
    PCBreadNav,
    PCOrderStep,
    successMain,
    PCButton,
    hHead
  },
  data() {
    return {
      email: '',
      data: ''
    };
  },
  computed: {
    // 判断是否是 PC 端
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  created() {
    this.data = JSON.parse(this.$route.query.data);
    console.log(this.data);
  },
  mounted() {
    this.email = this.$route.query?.email;
  },
  methods: {
    // 跳转页面
    toPage() {
      if (!this.checked) {
        return;
      }
      this.$router.push('/product');
    },
    handleSubmit() {
      const channelId = getChannelId();

      // 100080 渠道跳转到 vivo-official.com
      if (channelId === '100080') {
        window.open('https://vivo-official.com/', '_blank');
        return;
      }

      // 100000 和 100070 渠道跳转到 vivoonlinestore.com
      if (channelId === '100000') {
        const productName = sessionStorage.getItem('productName');
        console.log(productName);
        if (productName) {
          window.open(`https://vivoonlinestore.com/products/${productName}?status=tradein-success`, '_blank');
        } else {
          window.open('https://vivo-official.com/', '_blank');
        }

        return;
      }

      if (channelId === '100070') {
        const productName = sessionStorage.getItem('productName');
        console.log(productName);
        if (productName) {
          window.open(`https://vivo-official.com/products/${productName}?status=tradein-success`, '_blank');
        } else {
          window.open('https://vivo-official.com/', '_blank');
        }

        return;
      }


    }
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  .success-order {
    padding: 88px 40px 0;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    // overflow: scroll;
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    img {
      width: 622px;
      margin-bottom: 32px;
    }
    .tip {
      margin-bottom: 22px;
      .title {
        width: 100%;
        text-align: center;
        color: #405fff;
        font-size: 36px;
        font-weight: 700;
        line-height: 48px;
        margin-bottom: 4px;
      }
      .tips {
        color: #333;
        font-size: 28px;
        line-height: 48px;
      }
    }
    .attention {
      width: 100%;
      background: #f7f7f7;
      border-radius: 16px;
      margin-bottom: 302px;
      padding: 24px 0;
      .margin-4 {
        margin-bottom: 4px;
      }
      div {
        padding: 0 20px 0 46px;
        color: #666;
        font-size: 28px;
        line-height: 48px;
        position: relative;
        span {
          color: #333;
          font-weight: 700;
        }
        &:before {
          content: '';
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #666;
          position: absolute;
          top: 26px;
          left: 20px;
        }
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 10px 24px !important;
    font-size: 28px;
    .btn-photo {
      height: 80px;
      width: 100%;
      text-align: center;
      line-height: 80px;
      background: #405fff !important;
      color: #fff !important;
      border-radius: 5px;
      opacity: 0.5;
      border-radius: 16px;
    }
    .btn-active {
      background: #405fff !important;
      color: #fff !important;
      opacity: 1 !important;
      width: 100%;
    }
  }
}
@media (min-width: 981px) {
  .pc_success-order {
    width: 1200px;
    margin: 100px auto 48px;
    .success-main {
      width: 1200px;
      background: #fff;
    }
  }
  .success-order {
    display: none;
  }
}
</style>
